import { Component } from "react";
import { siteConfig } from "../lib/siteConfig";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep a useful console trail for us while customers see a reload prompt.
    console.error(`${siteConfig.name} frontend error`, error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const isAdmin = window.location.pathname.startsWith("/admin");

    if (isAdmin) {
      return (
        <div className="grid min-h-screen place-items-center bg-[#05070D] p-6 text-white">
          <div className="max-w-md rounded-2xl border border-white/10 bg-white/[0.04] p-6 text-center">
            <h1 className="font-display text-2xl font-black">Admin panel needs a refresh</h1>
            <p className="mt-2 text-sm text-white/60">Something failed while loading this view.</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-5 rounded-full bg-[#2F6FA5] px-5 py-3 font-bold text-white"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="grid min-h-screen place-items-center bg-[#05070D] p-6 text-white">
        <div className="max-w-md rounded-2xl border border-[#2F6FA5]/30 bg-[#07101D] p-6 text-center shadow-2xl shadow-black/50">
          <h1 className="font-display text-2xl font-black">Please refresh</h1>
          <p className="mt-2 text-sm text-white/60">Something did not load correctly on this page.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 rounded-full bg-[#2F6FA5] px-5 py-3 font-bold text-white"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
